






import Vue from "vue";

import IconTerms from "@joyz/app-core/assets/icons/default/Terms.svg";

import LegalDocLayout from "@tt-app/components/user/settings/LegalDocLayout.vue";

// @ts-ignore
import UserAgreement from "@tt-app/views/user/markdown/user-agreement.md";

interface Computed {
  titleIcon: string;
}

export default Vue.extend<{}, {}, Computed, {}>({
  name: "UserTermsOfServices",
  components: { LegalDocLayout },

  data() {
    return {
      userAgreement: UserAgreement
    };
  },

  computed: {
    titleIcon: () => IconTerms
  }
});
